import React from "react";
import styled from "styled-components";
import theme from "../../../assets/theme";

const Wrap = styled.div`
  text-align: center;
  padding: 48px 20px;
`;

const Icon = styled.div`
  font-size: 36px;
  color: #b8c2ce;
  margin-bottom: 10px;
`;

const Title = styled.div`
  font-family: ${theme.fonts.primaryFontBold};
  font-size: 14px;
  font-weight: 700;
  color: #5c6b7f;
  margin-bottom: 4px;
`;

const Subtitle = styled.div`
  font-family: ${theme.fonts.primaryFontRegular};
  font-size: 12px;
  color: #8e99a8;
`;

const EmptyState = ({ icon = "□", title, subtitle }) => (
  <Wrap>
    <Icon>{icon}</Icon>
    <Title>{title}</Title>
    {subtitle && <Subtitle>{subtitle}</Subtitle>}
  </Wrap>
);

export default EmptyState;
